import { render, staticRenderFns } from "./MarketingStatistics.vue?vue&type=template&id=faba3b8c"
import script from "./MarketingStatistics.vue?vue&type=script&lang=js"
export * from "./MarketingStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports